var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Beszállási külső form")]),_c('form',[_c('div',{staticClass:"form-group"},[_c('input',{attrs:{"type":"text"}})])])])
}]

export { render, staticRenderFns }